module.exports = __webpack_public_path__ + "img/8A3DA1_D77CE4_C263D4_B75AC9-256px.8ce76d71.png";